import React from "react";

const AnalyticsReferral = () => {
  return <div>AnalyticsReferral</div>;
};

export default AnalyticsReferral;